import { ChangeDetectorRef, Component, Renderer2, signal } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { Pair } from "../obj/Pair";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { User } from "../entity/User";
import { HeaderComponent } from "./incs/header.component";
import { FormsModule } from "@angular/forms";


@Component({
    selector: "[kilowant-login]",
    templateUrl: "../../html/main-login.html",
    imports: [HeaderComponent, FormsModule]
})
export class LoginComponent extends AbstractComponent {
    showError: boolean = false;
    error: string = "";
    login: string = "";
    showSendActivation: boolean = false;
    password: string = "";
    passwordType: string = "password";
    redirect: string = "";
    loginEmail = signal<string | null>(null);

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private renderer: Renderer2,
        private authService: AuthService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
    }

    ngOnInit(): void {
        this.analyticsService.trackEvent("Login Page", "User Opens Login Page", "OPEN_PAGE");
        var body = document.getElementsByTagName("body")[0];
        body.classList.add("loginDiv");
        super.ngOnInit();
    }

    pageStart(): void {
        this.authService.authActivities$.subscribe(
            email => {
                if (email != null && email.length > 0) {
                    this.login = email;
                    this.loginEmail.set(email);
                }
            });

        this.route.queryParams.subscribe((params: any) => {
            var redirectParam = params["redirect"];
            if (redirectParam != null && redirectParam != "" && redirectParam.length > 0) {
                this.redirect = redirectParam;
            }
            if (this.router.url == "/user/logout") {
                this.authService.logout();
                this.router.navigate(["/user/login"]);
            } else if (this.authService.isLoggedIn()) {
                this.doRedirect(null);
            }
            this.changeDetectorRef.detectChanges();
        });
        if (this.generalService.getFromSession("loginEmail") != null) {
            let email = <string>this.generalService.getFromSession("loginEmail");
            if (email != null && email.length > 0) {
                this.login = email;
                this.loginEmail.set(email);
            }
        }
    }

    clearLoginUser(): void {
        this.loginEmail.set(null);
        this.generalService.clearFromSessionByPrefix("loginEmail");
    }

    showPassword() {
        if (this.passwordType === "password") {
            this.passwordType = "text";
        } else {
            this.passwordType = "password";
        }
    }

    goToForgotPassword(): void {
        this.router.navigate(["/user/forgot-password"]);
    }

    goToRegister(): void {
        this.router.navigate(["/user/registration"]);
    }

    sendForm(): void {
        this.generalService.cleanUserRequest();
        this.authService.login(this.login, this.password).subscribe(
            {
                next: (response: Pair) => {
                    this.doRedirect(response);
                },
                error: (err: any) => {
                    if (err.status == 400 && err.error == "No Activation") {
                        this.showError = false;
                        this.error = "";
                        this.showSendActivation = true;
                        this.analyticsService.trackEvent("Error In Form User Login", "User gets an error on the form to login: [No Activation] on the Login Page", "FORM_ERROR");
                    }
                    if (err.status == 400 && err.error != "No Activation") {
                        this.showError = true;
                        this.showSendActivation = false;
                        this.error = err.error;
                        this.analyticsService.trackEvent("Error In Form User Login", "User gets an error on the form to login: [" + this.error + "] on the Login Page", "FORM_ERROR");
                    }
                    if (err.status == 401) {
                        this.showError = true;
                        this.error = "Email or Password is not correct.";
                        this.analyticsService.trackEvent("Error In Form User Login", "User gets an error on the form to login: [" + this.error + "] on the Login Page", "FORM_ERROR");
                    }
                }
            }
        );
    }

    doRedirect(response: Pair | null): void {
        if (this.redirect != "") {
            this.router.navigateByUrl(this.redirect);
            return;
        }
        this.generalService.getDetails().then((u) => {
            if (u == null) {
                this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
                this.analyticsService.trackEvent("Error On User Login", "User gets an unknown error on the form to login on the Login Page", "FORM_ERROR");
            }
            if (u != null && u.isSupplier) {
                this.analyticsService.trackEvent("Seller User Login", "Seller User logins", "USER_LOGIN");
                this.router.navigate(["/seller/home"]);
            } else {
                this.analyticsService.trackEvent("Buyer User Login", "Buyer User logins", "USER_LOGIN");
                this.getBuyerRedirectData(u);
            }
        });
    }

    resetError(): void {
        this.showError = false;
        this.showSendActivation = false;
    }

    getBuyerRedirectData(user: User) {
        if (user.isAdvisor) {
            this.router.navigate(["user/home"]);
            return;
        }
        if (user.kilowantUViewed == null || !user.kilowantUViewed) {
            this.router.navigate(["user/kilowant-u"]);
        } else {
            this.generalService.getAccountsExist().then((accountsExists: boolean) => {
                if (accountsExists) {
                    this.router.navigate(["user/home"]);
                } else {
                    this.generalService.clearStoredAccount();
                    this.router.navigate(["account/onboarding"]);
                }
            });
        }
    }
    showHome(): void {
        this.router.navigate(["/"]);
    }
}
